import { Icon } from './Icon';

export interface TimelineItem {
  state: 'done' | 'current' | 'todo';
  title: string;
  text: string;
}

/** Vertical timeline (check-in, stay, check-out). */
export function Timeline({ items }: { items: TimelineItem[] }) {
  return (
    <ol className="pv-card pv-timeline">
      {items.map((item, i) => (
        <li key={item.title} className={`is-${item.state}`}>
          <span className="pv-timeline__dot" aria-hidden="true">
            {item.state === 'done' && <Icon name="check" size={16} />}
            {item.state === 'current' && <i />}
            {item.state === 'todo' && i + 1}
          </span>
          <div>
            <div className="pv-timeline__title">{item.title}</div>
            <div className="pv-muted pv-small">{item.text}</div>
          </div>
        </li>
      ))}
    </ol>
  );
}
